const POLL_OPTION_LABEL_FIELDS = ["value", "text", "label", "option"];

const toPollOptionLabel = (value: unknown) => {
  if (typeof value === "string") {
    return value.length > 0 ? value : null;
  }

  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }

  return null;
};

const normalizePollOption = (option: unknown) => {
  const directLabel = toPollOptionLabel(option);
  if (directLabel !== null) {
    return directLabel;
  }

  if (!option || typeof option !== "object" || Array.isArray(option)) {
    return null;
  }

  const optionRecord = option as Record<string, unknown>;
  for (const field of POLL_OPTION_LABEL_FIELDS) {
    const label = toPollOptionLabel(optionRecord[field]);
    if (label !== null) {
      return label;
    }
  }

  return null;
};

export const normalizePollOptions = (options: unknown) => {
  if (!Array.isArray(options)) {
    return [];
  }

  return options.flatMap((option) => {
    const label = normalizePollOption(option);
    return label === null ? [] : [label];
  });
};
